import { CalculatorIcon, DocumentIcon, HouseSBABIcon, LightbulbIcon, UserIcon, WalletIcon } from '@/icons';

const customers = [
  {
    logo: HouseSBABIcon,
    title: 'Bostadsutvecklare',
  },
  {
    logo: UserIcon,
    title: 'Mäklare',
  },
  {
    logo: WalletIcon,
    title: 'Banker',
  },
  {
    logo: LightbulbIcon,
    title: 'Kommuner',
  },
  {
    logo: DocumentIcon,
    title: 'Myndigheter',
  },
  {
    logo: CalculatorIcon,
    title: 'Analytiker',
  },
];

const WhatIsPro = () => {
  return (
    <>
      <div className='tablet:flex-col flex w-full items-center justify-between'>
        <div className='max-w-xl pr-6'>
          <h2 className='mobile:text-lg text-xl'>Vad är Booli Pro?</h2>
          <p className='tablet:text-3xl mobile:text-2xl mt-1 text-4xl font-semibold'>
            Ett analysverktyg för professionella aktörer
          </p>
          <p className='mt-6'>
            Booli Pro är ett analysverktyg för professionella aktörer på bostadsmarknaden och är en del av SBAB:s trygga
            och enkla tjänster. Det innehåller löpande uppdaterad data om successions- och nyproduktionsmarknaden samt
            bostadsrättsföreningar.
          </p>
        </div>
        <h3 className='tablet:mt-10 tablet:items-end flex w-full flex-col'>
          <span className='mobile:text-6xl text-center text-8xl font-semibold'>100+</span>
          <span className='mobile:text-xl text-center text-3xl font-semibold'>företagskunder</span>
        </h3>
      </div>
      <div className='mt-10 flex flex-col gap-6'>
        <h3 className='font-display text-xl'>Några av våra kunder</h3>
        <ul className='mobile:flex-wrap mobile:gap-x-0 flex gap-x-6'>
          {customers.map((customer) => {
            return (
              <li
                key={customer.title}
                className='mobile:w-1/3 flex flex-col flex-wrap items-center justify-between'
              >
                <customer.logo className='text-bui-color-orange mb-2 h-16 w-16' />
                <p>{customer.title}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default WhatIsPro;
